export default __webpack_public_path__ + "static/BusinessCard-3fb6f0cd3edbd504eec2bea7a902c1eb.png";